import {
    createRGBATransformHighlight,
    type RenderStateGroupAction,
    type RenderStateToonOutline,
} from "@novorender/api";

import type { VecRGB, VecRGBA } from "utils/color";

/** Legacy bim-webviewer x-ray fill, 20% darker than `#bbbbbb`, at 30% opacity. */
export const DEFAULT_XRAY_COLOR: VecRGBA = [0.586, 0.586, 0.586, 0.3];

/** Soft gray toon edges for transparent x-ray geometry. */
export const XRAY_TOON_OUTLINE_COLOR: VecRGB = [0.45, 0.45, 0.45];

/** 1 replaces material color (legacy monochromatic). 0 keeps original hues. */
export const XRAY_MATERIAL_TINT = 1;

export function rgbFromRgba(color: VecRGBA): VecRGB {
    return [color[0], color[1], color[2]];
}

export function createXRayDefaultAction(color: VecRGBA): RenderStateGroupAction {
    const [r, g, b, a] = color;
    const tint = XRAY_MATERIAL_TINT;
    return createRGBATransformHighlight({
        red: { scale: 1 - tint, offset: r * tint },
        green: { scale: 1 - tint, offset: g * tint },
        blue: { scale: 1 - tint, offset: b * tint },
        opacity: a,
    });
}

export function resolveToonOutline({
    isXRayActive,
    isSectionPlanePickerActive,
    toonOutlineSettings,
}: {
    isXRayActive: boolean;
    isSectionPlanePickerActive: boolean;
    toonOutlineSettings: Partial<RenderStateToonOutline> & { onlyOnIdleFrame?: boolean };
}): Partial<RenderStateToonOutline> {
    if (isXRayActive) {
        // Respect the user's toon outline setting -- x-ray only styles outlines, it never re-enables them.
        if (toonOutlineSettings.enabled === false) {
            return { ...toonOutlineSettings, on: false };
        }

        return {
            ...toonOutlineSettings,
            enabled: true,
            on: true,
            color: XRAY_TOON_OUTLINE_COLOR,
        };
    }

    if (isSectionPlanePickerActive) {
        return { ...toonOutlineSettings, enabled: true, on: true };
    }

    return { ...toonOutlineSettings, on: false };
}
